import { useQuery } from "@tanstack/react-query";
import { ClusterJobs } from "@graylog/server-api";
import { defaultOnError } from "util/conditional/onError";
export const SYSTEM_JOBS_QUERY_KEY = ["system", "jobs"];
const useSystemJobs = () => {
  const { data: jobs } = useQuery({
    queryKey: SYSTEM_JOBS_QUERY_KEY,
    queryFn: () => defaultOnError(ClusterJobs.list(), "Loading system jobs failed with status", "Could not load system jobs"),
    refetchInterval: 2e3
  });
  return jobs;
};
export default useSystemJobs;
